import Api from "./Api";
import Csrf from "./Csrf";

export default {   
    
  async update(id,form) {
    await Csrf.getCookie();

    return Api.patch("/locations/"+id, form);
  },
    
  async index() {
    await Csrf.getCookie();

    return Api.get("/locations");
  },
    
  async indexlinear() {
    await Csrf.getCookie();

    return Api.get("/locations/linear");
  },
    
  async add(form) {
    await Csrf.getCookie();

    return Api.post("/locations", form);
  },
    
  async delete(id) {
    await Csrf.getCookie();

    return Api.delete("/locations/" + id);      
      
  },
    
  async show(id) {
    await Csrf.getCookie();

    return Api.get("/locations/" + id);      
      
  },
    
};